import { Tile } from "@src/cloud-connect/blueprint/dashboards/entities/tile";

export class PostCreateDashboardTilesPayloadBuilder {
  private source_id: string;
  private namespace: string;
  private tiles: Tile[];

  constructor(source_id: string, namespace: string, tiles: Tile[]) {
    this.source_id = source_id;
    this.namespace = namespace;
    this.tiles = tiles;
  }

  build() {
    return {
      source_id: this.source_id,
      namespace: this.namespace,
      data: {
        tiles: this.tiles,
      },
    };
  }
}
